'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { KOALA } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Fragment, useState } from 'react';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UITile from 'UIComponents/tile/UITile';
import FeaturesModal from './FeaturesModal';
import { getProductFeatureDescriptionKey } from 'self-service-api/core/utilities/getFeatureDescriptionKey';
import ChecklistItem from 'pricing-pages-unified-ui/components/common/ChecklistItem';
import breakpoint from '../../utils/responsiveBreakpoints';
import { OPERATIONS } from 'self-service-api/constants/ProductLines';
const TileFeatureListContainer = styled.div.withConfig({
  displayName: "FeatureTile__TileFeatureListContainer",
  componentId: "sc-140qq2v-0"
})(["padding:45px 25px 15px;"]);
const TileHeader = styled.div.withConfig({
  displayName: "FeatureTile__TileHeader",
  componentId: "sc-140qq2v-1"
})(["font-size:15px;font-weight:700;text-transform:uppercase;margin-bottom:27px;"]);
const TileViewMoreContainer = styled.div.withConfig({
  displayName: "FeatureTile__TileViewMoreContainer",
  componentId: "sc-140qq2v-2"
})(["width:100%;padding:10px 25px;border-top:1px solid ", ";font-size:14px;text-align:center;"], KOALA);
const FeatureTileContainer = styled(UITile).withConfig({
  displayName: "FeatureTile__FeatureTileContainer",
  componentId: "sc-140qq2v-3"
})(["display:flex;flex-direction:column;flex:1;margin-top:0 !important;margin-right:10px;&:last-child{margin-right:0;}", ""], breakpoint.tabletPortrait(_t || (_t = _`
    margin-bottom: 10px;
    margin-right: 0;
  `)));

function FeatureTile({
  modalViewClassName,
  header,
  features,
  productLine
}) {
  const [featuresModalVisible, setFeaturesModalVisible] = useState(false);
  const keys = productLine === OPERATIONS ? Object.keys(features).slice(0, 3) : Object.keys(features).slice(0, 5);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(FeatureTileContainer, {
      children: [/*#__PURE__*/_jsxs(TileFeatureListContainer, {
        children: [/*#__PURE__*/_jsx(TileHeader, {
          children: header
        }), keys.map(feature => /*#__PURE__*/_jsx(ChecklistItem, {
          tooltipMessage: getProductFeatureDescriptionKey(feature, productLine),
          message: `pricing-pages.features.${feature}.name`,
          className: "m-bottom-4"
        }, feature))]
      }), /*#__PURE__*/_jsx("div", {
        className: "flex flex-grow-1 align-end",
        children: /*#__PURE__*/_jsx(TileViewMoreContainer, {
          children: /*#__PURE__*/_jsx(UIButton, {
            className: modalViewClassName,
            use: "link",
            onClick: () => {
              setFeaturesModalVisible(true);
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              className: modalViewClassName,
              message: "pricingPage.pages.crm.viewMore"
            })
          })
        })
      })]
    }), featuresModalVisible && /*#__PURE__*/_jsx(FeaturesModal, {
      header: header,
      features: features,
      productLine: productLine,
      onModalClose: () => {
        setFeaturesModalVisible(false);
      }
    })]
  });
}

export default FeatureTile;